import { useQuery } from "@tanstack/react-query";
import { toolboxAskApi } from "@/lib/api/toolbox-ask";

/**
 * TanStack Query hooks for Product Q&A (epic PI-SPEC-SW-E310, feature
 * PI-SPEC-SW-1628). Only the product list comes from SpecTree; every question
 * goes to the person's own Claude through the Toolbox bridge.
 */
export const askKeys = {
  all: ["toolbox-ask"] as const,
  products: () => [...askKeys.all, "products"] as const,
};

/** The products the person may ask about (`GET /toolbox/ask/products`). Disabled until `enabled`. */
export function useAskProducts(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: askKeys.products(),
    queryFn: () => toolboxAskApi.listProducts(),
    staleTime: 60_000,
    enabled: options.enabled ?? true,
  });
}
